<template>
  <div class="reportTable">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div style="width: 100%; height: 100%">
        <div class="form-content">
          <div class="formTitle">
            <span>账号</span>
            <span style="flex:2">到店</span>
            <span style="flex:2">离店</span>
            <span>姓名</span>
            <span>房型</span>
            <span>房号</span>
            <span>房间数</span>
            <span>间夜数</span>
            <span>房价</span>
            <span>房费</span>
            <span>当时状态</span>
          </div>
        </div>
        <div class="formContaniner">
          <transition-group name="preArrivalList" tag="p">
            <div v-for="(outItem, index) in preArrivalList" v-bind:key="index" >
              <div class="PreArrivalItem" v-for="(item, index2) in outItem.records">
                <div>{{ item.accNo }}</div>
                <div style="flex:2">{{ item.arrival }} {{item.arrivalTime}}</div>
                <div style="flex:2">{{ item.departure }} {{item.departureTime}}</div>
                <div>{{item.guestName}}</div>
                <div>{{ item.roomtypename }}</div>

                <div>{{ item.roomname }}</div>
                <div>{{ item.roomNum }}</div>
                <div>{{ item.nights }}</div>
                <div style="text-align:right">{{ $parent.curreny(item.price) }}</div>
                <div style="text-align:right">{{ $parent.curreny(item.roomFee) }}</div>
                <div v-if="item.status=='R'">预定</div>
                <div v-else-if="item.status=='I'">在店</div>
                <div v-else-if="item.status=='O'">离店</div>
                <div v-else-if="item.status=='S'">悬单</div>
                <div v-else></div>
              </div>
              <div class="PreArrivalItem xiaoji">
                <div></div>
                <div style="flex:2"></div>
                <div style="flex:2">小计</div>
                <div>{{ outItem.sourceName }}</div>
                <div></div>
                <div></div>
                <div>{{ outItem.roomNum }}</div>
                <div>{{ outItem.nights }}</div>
                <div></div>
                <div style="text-align:right">{{ $parent.curreny(outItem.roomFee) }}</div>
                <div></div>
              </div>
            </div>
          </transition-group>
        </div>

        <!-- <div class="formTitle" style="border:none;font-weight:bold">
          <span></span>
          <span></span>
          <span>合计</span>
          <span></span>
          <span>{{ record }}条记录</span>
          <span></span>
          <span>{{ room }}间</span>
          <span>{{ $parent.curreny(total) }}</span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import { getRequest, postRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 记录
      record: "",
      room: "",
      total: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      date: "",
      // dodayin: false,
      visible: true,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "U93 订单来源房型区间报表";
    this.$parent.closeshow();
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");

    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;

    this.$parent.chaxunvib = true;
    //显示需要用的搜索
    // this.$parent.startTimeShow = true;
    // this.$parent.endTimeShow = true;
    this.getPreArrivalList();
  },
  methods: {
    doserach() {
      this.getPreArrivalList();
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    confirm() {
      // this.$print(this.$refs.print);
      this.close();
    },
    close() {
      this.visible = false;
      // this.dodayin = false;
    },

    dateChange(data) {
      //
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getPreArrivalList() {
      this.total = 0;
      this.room = 0;
      this.preArrivalList=[];
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/report/selectListU93", {
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate
      }).then(res => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.$parent.datacount = res.data.length;
          let list2 = [];
          if (res.data) {
            res.data.forEach(item => {
              item.roomNum = 0;
              item.nights = 0;
              item.roomFee = 0;
              item.records.forEach(item2 => {
                item.roomNum += parseFloat(item2.roomNum);
                item.nights += parseFloat(item2.nights);
                item.roomFee += parseFloat(item2.roomFee);
                list2.push(item2);
              });
            });
          }
          this.$store.state.preArrivalList = list2;
          this.$store.state.preArrivalName = "U93.订单来源房型区间报表";
          this.preArrivalList = res.data;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
.formTitle > span {
  flex: 1;
}
.PreArrivalItem > div {
  flex: 1;
}
.xiaoji {
  border-top: 1px dotted black;
  border-bottom: 1px solid black;
}
</style>

